import { AdElementText, DateTimeFormat } from '@adflow/types';
import { FormLabel, Radio, RadioGroup, Stack } from '@chakra-ui/react';
import { FC, useCallback } from 'react';
import { useStore } from '../../../../hooks/useStore';

type Props = {
  textElement: AdElementText;
};

export const isMonthPresent = (textElement: AdElementText) => {
  if (!textElement.sources?.length) return false;
  return textElement.sources.some((s) => textElement.data.content.includes(`${s.sourceId}:MONTH}`));
};

const MonthFormatControls: FC<Props> = ({ textElement }) => {
  const s = useStore((state) => ({
    displayOptions: state.displayOptions,
    setElementDateDisplayOptions: state.setElementDateDisplayOptions,
  }));

  const dateDisplayOptions: DateTimeFormat | null | undefined =
    textElement.data.dateDisplayOptions || s.displayOptions.dateTimeFormat;

  const handleUpdateMonthFormat = useCallback(
    (value: string) => {
      let monthFormat = dateDisplayOptions?.monthFormat;
      if (monthFormat == null) {
        monthFormat = 'long';
      }

      if (value !== 'short' && value !== 'long') return;
      monthFormat = value;
      s.setElementDateDisplayOptions(textElement.id, {
        ...dateDisplayOptions,
        monthFormat: monthFormat,
      });
    },
    [s, dateDisplayOptions, textElement.id],
  );

  return (
    <>
      <Stack direction="row" mb={2}>
        <FormLabel htmlFor="time-format" mb={'0'} style={{ fontVariant: 'all-small-caps' }}>
          Month
        </FormLabel>
        <RadioGroup
          value={dateDisplayOptions?.monthFormat || 'long'}
          id="time-format"
          ml={'auto'}
          mr={0}
          onChange={handleUpdateMonthFormat}
        >
          <Stack direction="row">
            <Radio value="short">Abbreviated</Radio>
            <Radio value="long">Full</Radio>
          </Stack>
        </RadioGroup>
      </Stack>
    </>
  );
};

MonthFormatControls.displayName = 'MonthFormatControls';

export default MonthFormatControls;
